import StorageService from '@/common/storage.service';
import { LoginService } from '@/common/login.service';
import Spinner from '../Spinner.vue';

export default {
  name: 'TrackingModal',
  components: {
    Spinner,
  },
  props: {
    loginUrl: {
      required: true,
      type: String,
    },
    fairEventUids: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      showModal: false,
      lmsUser: null,
      loginService: null,
    };
  },
  created() {
    this.loginService = new LoginService(this.loginUrl);
    this.loadUser();
    this.setShowModal();
  },
  methods: {
    loadUser() {
      const lmsUserData = StorageService.getItem('buyerData');
      if (lmsUserData) {
        this.lmsUser = JSON.parse(lmsUserData);
      }
    },
    setShowModal() {
      this.showModal = !this.hasConfiguredTracking;
    },
    async allowTracking() {
      try {
        const requests = [];
        this.fairEventUids.forEach(f => requests.push(this.loginService.setTrackingEnabled(f, true)));
        await Promise.all(requests);
        this.loadUser();
        this.setShowModal();
        this.$emit('allow');
      } catch (e) {
        console.error(e);
      }
    },
    async objectTracking() {
      try {
        const requests = [];
        this.fairEventUids.forEach(f => requests.push(this.loginService.setTrackingEnabled(f, false)));
        await Promise.all(requests);
        this.loadUser();
        this.setShowModal();
        this.$emit('object');
      } catch (e) {
        console.error(e);
      }
    },
  },
  computed: {
    hasConfiguredTracking() {
      if (this.lmsUser) {
        return this.lmsUser.permissions.filter(p => this.fairEventUids.includes(p.fairEvent.id)).length === this.fairEventUids.length;
      }
      return false;
    },
  },
};
